var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeliveryTruck = function SvgDeliveryTruck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#145CC5",
    fillRule: "evenodd",
    d: "M1.667 3.5a.667.667 0 0 0 0 1.333h8.5V13.5H8.069a2.333 2.333 0 0 0-4.472 0h-.43v-2.667a.667.667 0 0 0-1.334 0v3.334c0 .368.299.666.667.666h1.097a2.333 2.333 0 0 0 4.472 0h3.862a2.333 2.333 0 0 0 4.472 0H17.5a.667.667 0 0 0 .667-.666v-5c0-.121-.033-.24-.095-.343l-2.5-4.167A.67.67 0 0 0 15 4.333h-3.5v-.166a.667.667 0 0 0-.667-.667zm14.736 10h.43V9.833H11.5V13.5h.43a2.332 2.332 0 0 1 4.473 0m-3.236.667a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-8.334 0a1 1 0 1 0 2 0 1 1 0 0 0-2 0M16.323 8.5H11.5V5.667h3.123z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#145CC5",
    d: "M2.5 6.833a.667.667 0 0 0 0 1.334h3.333a.667.667 0 0 0 0-1.334z"
  })));
};
export default SvgDeliveryTruck;